var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.school)?_c('div',[_c('img',{attrs:{"src":_vm.school.logo,"height":_vm.height ? _vm.height : '100px'}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }